import { useContext } from 'react';
import { DebugModeContext } from './debug-provider';

export const useDebugMode = () => {
  return useContext(DebugModeContext);
};
